import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Pagination } from './pagination';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
})
export class PaginationComponent implements OnInit {
    @Input() pagination!: Pagination;
    @Input() isRecordsPerPageDropdownEnable = true;
    @Output() changedPagination = new EventEmitter();

    ngOnInit(): void {
        console.log(this.pagination);
    }

    onPageSizeChange() {
        this.pagination.pageIndex = 0;
        this.changedPagination.emit(this.pagination);
    }

    onPageChange(pageEvent: any) {
        this.pagination.pageIndex = pageEvent.page;
        this.pagination.pageSize = pageEvent.rows;
        this.changedPagination.emit(this.pagination);
    }
}
